/**
 * 订单管理 数据列表
 */
<template>
	<div>
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>检测数据</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="page" class="user-search">
			<el-form-item label="搜索：">
				<!-- <el-input size="small" v-model="page.mn" @keydown.enter.native='search' placeholder="设备码"></el-input> -->
				<el-select size="small" v-model="page.mn" placeholder="请选择">
					<el-option v-for="type in companyList" :label="type.companyName" :value="type.mn" :key="type.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-date-picker v-model="date.date" align="right" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" :picker-options="date.pickerOptions"></el-date-picker>
			</el-form-item>
			<el-select size="small" v-model="page.cn">
				<el-option v-for="type in cn" :label="type.value" :value="type.key" :key="type.key"></el-option>
			</el-select>
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
			</el-form-item>

			<el-form-item>
				<el-popover placement="right" width="400" trigger="click">
					<el-checkbox v-model="item.isShow" :key="item.index" v-for="item in cols">{{item.avgName}}</el-checkbox>
					<el-button slot="reference" size="small" type="primary" icon="el-icon-set-up">设置</el-button>
				</el-popover>
			</el-form-item>

			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-download" @click="centerDialogVisible=true">导出</el-button>
			</el-form-item>
		</el-form>
		<div style="color:red">当前 {{resultLength}} 条</div>
		<!--列表-->
		<el-table size="small" :data="compuData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column align="center" type="index" width="60">
			</el-table-column>
			<template v-for="item in cols">
				<el-table-column sortable :key="item.index" v-if="item.isShow" :prop="getlet(item.name)"  :label="item.avgName" show-overflow-tooltip>
					<template v-if="isAvg(item.name)">
						<el-table-column sortable :key="item.index" v-if="item.name.indexOf('pB01Avg')==-1" :prop="item.name" :label="'实际值(mg/L)'" show-overflow-tooltip></el-table-column>
						<el-table-column sortable :key="item.index" v-if="item.name.indexOf('p001Avg')==-1" :prop="getCou(item.name)" :label="'累计值(kg)'" show-overflow-tooltip></el-table-column>
					</template>
				</el-table-column>
			</template>
		</el-table>
		<!-- 分页组件 -->
		<Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
		<div>
			<el-dialog title="选择导出日期" :visible.sync="centerDialogVisible" width="40%" center>
				<div style="text-align:center">
					<span class="demonstration">日期</span>
					<el-date-picker v-model="downloadDate" type="daterange" value-format="yyyy-MM-dd" align="center" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="date.pickerRangeOptions">
					</el-date-picker>
				</div>
				<span slot="footer" class="dialog-footer" style="letter-spacing: 50px">
					<el-button @click="dialogClose()">取 消</el-button>
					<el-button type="primary" @click="download()">导出</el-button>
				</span>
			</el-dialog>
		</div>

	</div>
</template>

<script>
import { dataList, downloadData } from '../../api/payMG';
import { getUserCompany } from '../../api/userMG';
import Pagination from '../../components/Pagination';
import { floatMultiply, timestampToTime } from '../../utils/util';
export default {
	data() {
		return {
			downloadDate: '',
			centerDialogVisible: false,
			//时间组件参数
			date: {
				pickerRangeOptions: {
					shortcuts: [
						{
							text: '最近一周',
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(
									start.getTime() - 3600 * 1000 * 24 * 7
								);
								picker.$emit('pick', [start, end]);
							},
						},
						{
							text: '最近一个月',
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(
									start.getTime() - 3600 * 1000 * 24 * 30
								);
								picker.$emit('pick', [start, end]);
							},
						},
						{
							text: '最近三个月',
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(
									start.getTime() - 3600 * 1000 * 24 * 90
								);
								picker.$emit('pick', [start, end]);
							},
						},
					],
				},
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
					shortcuts: [
						{
							text: '今天',
							onClick(picker) {
								picker.$emit('pick', new Date());
							},
						},
						{
							text: '昨天',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24);
								picker.$emit('pick', date);
							},
						},
						{
							text: '一周前',
							onClick(picker) {
								const date = new Date();
								date.setTime(
									date.getTime() - 3600 * 1000 * 24 * 7
								);
								picker.$emit('pick', date);
							},
						},
					],
				},
				date: new Date(),
			},
			//地区下拉框参数
			nm: [
				{ key: '399435XA5EIOT6', value: '克拉玛依南郊污水处理厂' },
				{ key: 'klmytcswyxgsjs', value: '克拉玛依第二污水处理厂' },
				{ key: 'XJHB0990DT1404', value: '克拉玛依石化园污水处理厂' },
				{ key: '399435XEA6CTGM', value: '哈密十三师污水厂出口' },
				{ key: '399435XAASBP30', value: '克拉玛依广胜水处理有限公司' },
				{ key: '399435XD7W3L9Z', value: '新疆梅花氨基酸有限公司' },
				{ key: '16372108BMZZSC', value: '中再生资源' },
			],
			//时间类型下拉框参数
			cn: [
				{ key: '2061', value: '小时数据' },
				{ key: '2051', value: '分钟数据' },
				{ key: '2031', value: '日数据' },
			],
			//表单查询加载
			loading: false,
			//表单字段参数
			cols: [
				{ isShow: true, avgName: '设备识别码', name: 'mn' },
				{ isShow: true, avgName: '时间', name: 'dateTime' },
				{ isShow: false, avgName: '噪声', name: 'pB03Avg' },
				{ isShow: false, avgName: '累计百分声级L10', name: 'pL10Avg' },
				{ isShow: false, avgName: '累计百分声级L5', name: 'pL5Avg' },
				{ isShow: false, avgName: '累计百分声级L50', name: 'pL50Avg' },
				{ isShow: false, avgName: '累计百分声计L90', name: 'pL90Avg' },
				{ isShow: false, avgName: '累计百分声级L95', name: 'pL95Avg' },
				{ isShow: false, avgName: '夜间等效声级Ld', name: 'pLdAvg' },
				{ isShow: false, avgName: '昼夜等效声级Ldn', name: 'pLdnAvg' },
				{ isShow: false, avgName: '30秒等效声级Leq', name: 'pLeqAvg' },
				{ isShow: false, avgName: '最小的瞬时声级', name: 'pLmnAvg' },
				{ isShow: false, avgName: '最大的瞬时声级', name: 'pLmxAvg' },
				{ isShow: false, avgName: '昼间等效声级Ln', name: 'pLnAvg' },
				{ isShow: false, avgName: 'O2含量', name: 'pS01Avg' },
				{ isShow: false, avgName: '烟气流速', name: 'pS02Avg' },
				{ isShow: false, avgName: '烟气温度', name: 'pS03Avg' },
				{ isShow: false, avgName: '烟气动压', name: 'pS04Avg' },
				{ isShow: false, avgName: '烟气湿度', name: 'pS05Avg' },
				{ isShow: false, avgName: '制冷温度', name: 'pS06Avg' },
				{ isShow: false, avgName: '烟道截面积', name: 'pS07Avg' },
				{ isShow: false, avgName: '烟气压力', name: 'pS08Avg' },
				{ isShow: false, avgName: '废气', name: 'pB02Avg' },
				{ isShow: false, avgName: '烟尘', name: 'p01Avg' },
				{ isShow: false, avgName: '二氧化硫', name: 'p02Avg' },
				{ isShow: false, avgName: '氮氧化物', name: 'p03Avg' },
				{ isShow: false, avgName: '一氧化碳', name: 'p04Avg' },
				{ isShow: false, avgName: '硫化氢', name: 'p05Avg' },
				{ isShow: false, avgName: '氟化物', name: 'p06Avg' },
				{ isShow: false, avgName: '氰化物(含氰化氢)', name: 'p07Avg' },
				{ isShow: false, avgName: '氯化氢', name: 'p08Avg' },
				{ isShow: false, avgName: '沥青烟', name: 'p09Avg' },
				{ isShow: false, avgName: '氨', name: 'p10Avg' },
				{ isShow: false, avgName: '氯气', name: 'p11Avg' },
				{ isShow: false, avgName: '二硫化碳', name: 'p12Avg' },
				{ isShow: false, avgName: '硫醇', name: 'p13Avg' },
				{ isShow: false, avgName: '硫酸雾', name: 'p14Avg' },
				{ isShow: false, avgName: '铬酸雾', name: 'p15Avg' },
				{ isShow: false, avgName: '苯系物', name: 'p16Avg' },
				{ isShow: false, avgName: '甲苯', name: 'p17Avg' },
				{ isShow: false, avgName: '二甲苯', name: 'p18Avg' },
				{ isShow: false, avgName: '甲醛', name: 'p19Avg' },
				{ isShow: false, avgName: '苯并(a)芘', name: 'p20Avg' },
				{ isShow: false, avgName: '苯胺类', name: 'p21Avg' },
				{ isShow: false, avgName: '硝基苯类', name: 'p22Avg' },
				{ isShow: false, avgName: '氯苯类', name: 'p23Avg' },
				{ isShow: false, avgName: '光气', name: 'p24Avg' },
				{
					isShow: false,
					avgName: '碳氢化合物(含非甲烷总烃)',
					name: 'p25Avg',
				},
				{ isShow: false, avgName: '乙醛', name: 'p26Avg' },
				{ isShow: false, avgName: '酚类', name: 'p27Avg' },
				{ isShow: false, avgName: '甲醇', name: 'p28Avg' },
				{ isShow: false, avgName: '氯乙烯', name: 'p29Avg' },
				{ isShow: false, avgName: '二氧化碳', name: 'p30Avg' },
				{ isShow: false, avgName: '汞及其化合物', name: 'p31Avg' },
				{ isShow: false, avgName: '铅及其化合物', name: 'p32Avg' },
				{ isShow: false, avgName: '镉及其化合物', name: 'p33Avg' },
				{ isShow: false, avgName: '锡及其化合物', name: 'p34Avg' },
				{ isShow: false, avgName: '镍及其化合物', name: 'p35Avg' },
				{ isShow: false, avgName: '铍及其化合物', name: 'p36Avg' },
				{ isShow: false, avgName: '林格曼黑度', name: 'p37Avg' },
				{ isShow: false, avgName: '其他气污染物', name: 'p99Avg' },
				{ isShow: true, avgName: '污水/m³', name: 'pB01Avg' },
				{ isShow: true, avgName: 'pH值/(mg/L)', name: 'p001Avg' },
				{ isShow: false, avgName: '色度', name: 'p002Avg' },
				{ isShow: false, avgName: '悬浮物', name: 'p003Avg' },
				{ isShow: false, avgName: '生化需氧量(BOD5)', name: 'p010Avg' },
				{
					isShow: true,
					avgName: '化学需氧量(CODcr)/(mg/L)',
					name: 'p011Avg',
				},
				{ isShow: false, avgName: '总有机碳', name: 'p015Avg' },
				{ isShow: false, avgName: '总汞', name: 'p020Avg' },
				{ isShow: false, avgName: '烷基汞', name: 'p021Avg' },
				{ isShow: false, avgName: '总镉', name: 'p022Avg' },
				{ isShow: false, avgName: '总铬', name: 'p023Avg' },
				{ isShow: false, avgName: '六价铬', name: 'p024Avg' },
				{ isShow: false, avgName: '三价铬', name: 'p025Avg' },
				{ isShow: false, avgName: '总砷', name: 'p026Avg' },
				{ isShow: false, avgName: '总铅', name: 'p027Avg' },
				{ isShow: false, avgName: '总镍', name: 'p028Avg' },
				{ isShow: false, avgName: '总铜', name: 'p029Avg' },
				{ isShow: false, avgName: '总锌', name: 'p030Avg' },
				{ isShow: false, avgName: '总锰', name: 'p031Avg' },
				{ isShow: false, avgName: '总铁', name: 'p032Avg' },
				{ isShow: false, avgName: '总银', name: 'p033Avg' },
				{ isShow: false, avgName: '总铍', name: 'p034Avg' },
				{ isShow: false, avgName: '总硒', name: 'p035Avg' },
				{ isShow: false, avgName: '锡', name: 'p036Avg' },
				{ isShow: false, avgName: '硼', name: 'p037Avg' },
				{ isShow: false, avgName: '钼', name: 'p038Avg' },
				{ isShow: false, avgName: '钡', name: 'p039Avg' },
				{ isShow: false, avgName: '钴', name: 'p040Avg' },
				{ isShow: false, avgName: '铊', name: 'p041Avg' },
				{ isShow: true, avgName: '氨氮(mg/L)', name: 'p060Avg' },
				{ isShow: false, avgName: '有机氮', name: 'p061Avg' },
				{ isShow: true, avgName: '总氮(mg/L)', name: 'p065Avg' },
				{ isShow: false, avgName: '石油类', name: 'p080Avg' },
				{ isShow: true, avgName: '总磷(mg/L)', name: 'p101Avg' },
			],
			//手动查询参数
			page: {
				page: {
					current: 1,
					size: 24,
				},
				mn: '',
				cn: '2061',
				startDate: '',
				endDate: '',
			},
			userparm: [], //搜索权限
			listData: [], //查询结果数据
			companyList: [],
			resultLength: 0,
			// 分页组件默认参数
			pageparm: {
				pageIndex: [24, 60],
				currentPage: 1,
				pageSize: 24, //每页显示条数
				total: 10, //
			},
		};
	},
	// 注册组件
	components: {
		Pagination,
	},
	computed: {
		compuData() {
			//污水 *3.6
			this.listData.forEach((e) => {
				e.pB01Avg = floatMultiply(e.pB01Avg, 3.6);
				const timeStr = timestampToTime(e.dateTime);
				e.dateTime = timeStr.slice(11);
			});
			return this.listData;
		},
	},
	/**
	 * 创建完毕
	 */
	created() {
		this.getCompanyList();
	},
	watch: {
		'page.mn'(newVal, oldVal) {
			if (newVal === '') {
				this.page.mn = null;
			}
		},
		'date.date'(newVal, oldVal) {
			this.page.startDate = newVal + ' 00:00:00';
			this.page.endDate = newVal + ' 23:59:59';
		},
	},

	/**
	 * 里面的方法只有被调用才会执行
	 */
	methods: {
		isAvg(name) {
			if (null != name && '' != name && name.indexOf('Avg') != -1) {
				console.log("成功2")
				return true;
			} else {
				console.log("成功2")
				return false;
			}
		},
		getCou(name) {
			if (null != name && '' != name && name.indexOf('Avg') != -1) {
				let newName = name.replace('Avg', 'Cou');
				return newName;
			}
			return name;
		},
		getlet(name) { 
			if (null != name && '' != name && name.indexOf('Avg') == -1) {
				return name;
			}
		},
		dialogClose() {
			this.centerDialogVisible = false;
		},
		download() {
			if (this.downloadDate == null || this.downloadDate == '') {
				this.$message.error('请选择导出时间');
				return;
			}
			// return;
			let param = this.page;
			param.cols = this.cols;
			param.startDate = this.downloadDate[0] + ' 00:00:00';
			param.endDate = this.downloadDate[1] + ' 23:59:59';
			downloadData(param).then((res) => {
				let blob = new Blob([res], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				});
				const href = URL.createObjectURL(blob); //创建新的URL表示指定的blob对象
				console.log('url:', href);
				const a = document.createElement('a'); //创建a标签
				a.style.display = 'none';
				a.href = href; // 指定下载链接
				a.download = '检测数据'; //指定下载文件名
				a.click(); //触发下载
				URL.revokeObjectURL(a.href); //释放URL对象
			});
		},
		getCompanyList() {
			getUserCompany({}).then((res) => {
				this.companyList = res.data.companyList;
				const date = new Date();
				const dateFormat =
					date.getFullYear() +
					'-' +
					(date.getMonth() + 1) +
					'-' +
					date.getDate();
				this.page.startDate = dateFormat + ' 00:00:00';
				this.page.endDate = dateFormat + ' 23:59:59';
				this.page.mn = this.companyList[0].mn;
				this.getdata(this.page);
			});
		},
		// 获取公司列表
		getdata(parameter) {
			this.loading = true;

			/***
			 * 调用接口，注释上面模拟数据 取消下面注释
			 */
			dataList(parameter)
				.then((res) => {
					this.loading = false;
					this.listData = res.data.records;
					this.resultLength = res.data.total;
					// 分页赋值
					this.pageparm.currentPage = res.data.current;
					this.pageparm.pageSize = res.data.size;
					this.pageparm.total = res.data.total;
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error('菜单加载失败，请稍后再试！');
				});
		},
		// 分页插件事件
		callFather(parm) {
			this.page.page.current = parm.currentPage;
			this.page.page.size = parm.pageSize;
			this.getdata(this.page);
		},
		// 搜索事件
		search() {
			this.getdata(this.page);
		},
	},
};
</script>

<style scoped>
.user-search {
	margin-top: 20px;
}
.userRole {
	width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/pay/Data.vue